<template>
  <div>
    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.name') }}
        </h6>
        <span class="body-2">
          {{ data.name }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.username') }}
        </h6>
        <span class="body-2">
          {{ data.username }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.phone') }}
        </h6>
        <span class="body-2">
          {{ data.phone ? formatPhone(data.phone) : '---' }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{$t('host.label.birthDate')}}
        </h6>
        <span class="body-2">
          {{ data.birth_date ? formatDateWithoutTime(data.birth_date) : '---' }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.cpf') }}
        </h6>
        <span class="body-2">
          {{ data.cpf ? formatDocument(data.cpf) : '---' }}
        </span>
      </v-col>

      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.rg') }}
        </h6>
        <span class="body-2">
          {{ data.rg ? data.rg : '---' }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          Host desde
        </h6>
        <span class="body-2">
          {{ formatDateWithoutTime(data.date_created) }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.customerName') }}
        </h6>
        <span class="body-2">
          {{ data.invoice_company_name ? data.invoice_company_name : '---' }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.customerCnpj') }}
        </h6>
        <span class="body-2">
          {{ data.cnpj ? formatDocument(data.cnpj) : '---' }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.taxRegime') }}
        </h6>
        <span class="body-2">
          {{ taxRegimeLabel }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.partner') }}
        </h6>
        <p class="body-2 mb-0">
          {{ data.partner ? data.partner.name : '---'}}
        </p>
        <p class="caption grey--text mb-0">
          {{ data.partner ? data.partner.description : '' }}
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          Cidade
        </h6>
        <span class="body-2">
          {{ data.city.name }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { catalogDate, catalogPhone, catalogDateWithoutTime } from '@/util/catalog'
import { formatDocument } from '@/util/document'

export default {
  name: 'HostBasicInfo',

  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      formatDocument,
      dateTime: catalogDate,
      formatDateWithoutTime: catalogDateWithoutTime,
      formatPhone: catalogPhone,
    }
  },

  computed: {
    taxRegimeLabel() {
      if (!this.data.tax_regime) return '---'

      const key = `host.taxRegime.${this.data.tax_regime}`
      const translated = this.$t(key)

      if (translated && translated !== key) {
        return translated
      }

      return this.data.tax_regime.replace(/_/g, ' ')
    },
  },
}
</script>
